var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.plaintext)?_c('div',{staticClass:"md"},[_vm._v(_vm._s(_vm.plaintextContent))]):_c('div',{staticClass:"md",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }